import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatApiErrorDetail } from "@/lib/api";
import { PaymentDialog } from "@/components/PaymentDialog";

export function DiscountDialog({ ad, onClose, onSaved, L }) {
  const [pct, setPct] = useState("");
  const [days, setDays] = useState("");
  const [busy, setBusy] = useState(false);
  const current = ad && ad.discount_percent && ad.offer_until && new Date(ad.offer_until) > new Date();
  useEffect(() => { if (ad) { setPct(current ? String(ad.discount_percent) : ""); setDays(current && ad.offer_days ? String(ad.offer_days) : ""); } }, [ad]); // eslint-disable-line react-hooks/exhaustive-deps
  const save = async (clear) => {
    const p = parseFloat(pct); const d = parseInt(days, 10);
    if (!clear && !(p > 0 && p < 100)) return toast.error(L("نسبة الخصم يجب أن تكون بين 1 و 99", "Discount must be between 1 and 99"));
    if (!clear && !(d > 0)) return toast.error(L("حدد مدة صلاحية العرض بالأيام", "Set the validity in days"));
    setBusy(true);
    try {
      await api.post(`/listings/${ad.id}/discount`, clear ? { discount_percent: 0 } : { discount_percent: p, offer_days: d });
      toast.success(clear ? L("تم إلغاء الخصم", "Discount removed") : L(`تم تفعيل خصم ${p}% لمدة ${d} يوم`, `${p}% discount active for ${d} days`));
      onSaved(); onClose();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    setBusy(false);
  };
  const base = Number(ad?.base_price || 0);
  const p = parseFloat(pct);
  return (
    <Dialog open={!!ad} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-sm" data-testid="discount-dialog">
        <DialogHeader><DialogTitle>{L("قدم خصم", "Offer a discount")}</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">{L("يُطبَّق الخصم فوراً دون مراجعة الإدارة ويظهر للجميع كشارة \"خصم\".", "The discount applies instantly without admin review and shows as a \"Discount\" badge.")}</p>
        <label className="text-sm font-semibold">{L("نسبة الخصم (%)", "Discount (%)")}
          <input inputMode="numeric" value={pct} onChange={(e) => setPct(e.target.value.replace(/[^\d.]/g, ""))} className="mt-1 w-full h-11 rounded-xl border border-slate-200 px-3 outline-none focus:border-[#1A5C3A]" data-testid="discount-percent" /></label>
        <label className="text-sm font-semibold">{L("العرض صالح لمدة (أيام)", "Valid for (days)")}
          <input inputMode="numeric" value={days} onChange={(e) => setDays(e.target.value.replace(/\D/g, ""))} className="mt-1 w-full h-11 rounded-xl border border-slate-200 px-3 outline-none focus:border-[#1A5C3A]" data-testid="discount-days" /></label>
        {p > 0 && p < 100 && base > 0 && <p className="text-sm" data-testid="discount-preview">{L("السعر بعد الخصم", "Price after discount")}: <b dir="ltr">AED {Math.round(base * (1 - p / 100) * 100) / 100}</b></p>}
        <div className="flex gap-2">
          {current && <button disabled={busy} onClick={() => save(true)} className="h-11 px-4 rounded-xl border border-red-200 text-red-600 font-bold" data-testid="discount-clear">{L("إلغاء الخصم", "Remove")}</button>}
          <button disabled={busy} onClick={() => save(false)} className="flex-1 h-11 rounded-xl bg-[#1A5C3A] text-white font-bold flex items-center justify-center gap-2" data-testid="discount-save">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />}{current ? L("تحديث الخصم", "Update discount") : L("تأكيد الخصم", "Confirm discount")}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function PromoteDialog({ promo, onClose }) {
  if (!promo) return null;
  return <PaymentDialog req={{ listing_id: promo.ad.id, promo: true, renew: promo.renew }} onClose={onClose} />;
}
